import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  size?: 'lg' | 'xl';
}
export function Button({
  children,
  variant = 'primary',
  fullWidth,
  size = 'lg',
  className = '',
  ...props
}: ButtonProps) {
  const baseClasses = 'relative inline-flex items-center justify-center font-oswald uppercase tracking-wider font-bold transition-all duration-300 overflow-hidden group';
  const sizeClasses = {
    lg: 'px-6 py-3 text-base md:px-8 md:py-4 md:text-lg',
    xl: 'px-6 py-4 text-lg md:px-10 md:py-5 md:text-xl sm:text-2xl'
  };
  const variantClasses = {
    primary: 'bg-brand-orange text-white hover:bg-orange-600 box-glow-orange',
    secondary: 'bg-brand-blue text-white hover:bg-blue-600 box-glow-blue'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${widthClass} ${className}`} {...props} data-id="element-187">
      <span className="absolute inset-0 w-full h-full bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-188"></span>
      <span className="relative flex items-center gap-2" data-id="element-189">
        {children}
        <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-190" />
      </span>
    </motion.button>;
}